<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Logos</h1>
			</div>
		</div>
    <!--Content-->
		<div id="content">
      <h2>Logo color</h2>
      <div class="logo-box logo-box1 mt--bg--neutrals-light-gray-01" >
        <mt-logo :propWidth="300" />
      </div>


      <h2>Color usage</h2>
      <div class="iconBoxWrap">
        <div class="icon-box mt--bg--neutrals-light-gray-01">
          <mt-logo :propIsShowText="false" :propWidth="500"/>
        </div>
        <div class="icon-box mt--bg--neutrals-dark-gray-02">
          <mt-logo :propIsShowText="false" :propWidth="500" propColor="#ffffff" propIsWhiteIcon/>
        </div>
        <div class="icon-box mt--bg--neutrals-light-gray-01">
          <mt-logo :propIsShowText="false" :propWidth="500" propIsBlackIcon propColor="#485464"/>
        </div>
      </div>


		</div>
  </div>
</template>

<script>

export default {
  name: 'logos-page',
  props: [],
  components: {

  },
  data () {
    return {

    }
  },
  computed: {

  },

  methods: {

  },


}
</script>
<style lang="scss" scoped>
.logo-box {
  width: 800px;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 80px;
}
.icon-box {
  width: 250px;
  height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  float: left;
  margin-right: 16px;
  margin-bottom: 16px;
}
.iconBoxWrap {
  width: 800px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// Logos.vue?043d59f6